import { createContext } from 'react';

export const AppMainContext = /*#__PURE__*/createContext({});